import Api from '@/data/Api.ts';
import StringUtils from '@/infrastructure/support/utils/StringUtils.ts';

const URL_PLANT_CONTACT = '/companies/{0}/plants/{1}/contacts/{2}';
const URL_PLANT_CONTACTS = '/companies/{0}/plants/{1}/contacts';

export default class PlantContactsApi extends Api {
  index(companyId: number, plantId: number): Promise<any> {
    const url: string = StringUtils.stringFormat(URL_PLANT_CONTACTS, [
      companyId,
      plantId,
    ]);
    return this.standardGet(url, {}, []);
  }

  show(companyId: number, plantId: number, contactId: number): Promise<any> {
    const url: string = StringUtils.stringFormat(URL_PLANT_CONTACT, [
      companyId,
      plantId,
      contactId,
    ]);
    return this.standardGet(url, {}, []);
  }

  update(
    companyId: number,
    plantId: number,
    contactId: number,
    attributes: {},
  ): Promise<any> {
    const url: string = StringUtils.stringFormat(URL_PLANT_CONTACT, [
      companyId,
      plantId,
      contactId,
    ]);
    return this.standardPut(url, attributes);
  }

  store(companyId: number, plantId: number, attributes: {}): Promise<any> {
    const url: string = StringUtils.stringFormat(URL_PLANT_CONTACTS, [
      companyId,
      plantId,
    ]);
    return this.standardPost(url, attributes);
  }

  delete(companyId: number, plantId: number, contactId: number): Promise<any> {
    const url: string = StringUtils.stringFormat(URL_PLANT_CONTACT, [
      companyId,
      plantId,
      contactId,
    ]);
    return this.standardDelete(url);
  }
}
